export function commentsSlider() {

    let sliderWrap = $(".comments-slider-wrap");

    if (sliderWrap.length) {
        let curSlider = sliderWrap.find(".comments-slider");

        if (curSlider.find(".comments-slider-item").length > 1) {
            let arrowsContainer = sliderWrap.find(".slider-arrows");
            let dotsContainer = sliderWrap.find(".slider-dots");

            curSlider.slick({
                dots: true,
                arrows: true,
                infinite: false,
                slidesToShow: 2.22,
                slidesToScroll: 1,
                appendDots: dotsContainer,
                appendArrows: arrowsContainer,
                nextArrow: "<button><svg width='51' height='12' viewBox='0 0 51 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7V5ZM51 6L41 0.226497V11.7735L51 6ZM1 7H42V5H1V7Z' fill='#ED174F'/></svg></button>",
                prevArrow: "<button><svg width='51' height='12' viewBox='0 0 51 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.05176e-05 6L10 11.7735V0.226497L3.05176e-05 6ZM50 7C50.5523 7 51 6.55228 51 6C51 5.44772 50.5523 5 50 5V7ZM9.00003 7H50V5H9.00003V7Z' fill='#ED174F'/></svg></button>",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.2,
                            arrows: false,
                        },
                    },
                ],
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/commentsSlider.js